import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';

import {IconproduitFabriqueComponent} from './icon/iconproduit/icon-produitfab.component';
import {ViewmodeComponent} from './viewmode/viewmode.component';
import {ReadonlyComponent} from './forms/readonly/readonly.component';
import {InputTextComponent} from './forms/input-text/input-text.component';
import {ValidationComponent} from './forms/validation/validation.component';
import {SiteComponent} from './site/site.component';
import {CellButtonComponent} from './grid/cell-button/cell-button.component';
import {ConfirmDialogComponent} from './forms/confirm-dialog/confirm-dialog.component';
import {ButtonSaveComponent} from './forms/button-save/button-save.component';
import {ButtonDeleteComponent} from './forms/button-delete/button-delete.component';
import {DndModule} from 'ng2-dnd';
import {LoginComponent} from './login/login.component';
import {InputPasswordComponent} from './forms/input-password/input-password.component';
import {YoUserHasRightDirective} from '../core/services/security/yo-userhasright.directive';
import {InputFileComponent} from './forms/input-file/input-file.component';
import {CanDeactivateGuard} from './guards/can-deactivate.guard';
import {LoadingComponent} from './loading/loading.component';
import {BadgeComponent} from './badge/badge.component';
import {HttpClientModule} from '@angular/common/http';
import {IconLockComponent} from './icon/icon-lock/icon-lock.component';
import {DraggableDirective} from './ui/draggable.directive';
import {DroppableDirective} from './ui/droppable.directive';
import {DragService} from './ui/drag.service';
import {DialogMsgComponent} from './ui/dialog-msg/dialog-msg.component';
import {FamilleGemrcnComponent} from './icon/famille-gemrcn/famille-gemrcn.component';
import {CouleurComponent} from './ui/couleur/couleur.component';
import {ButtonSortComponent} from './ui/button-sort/button-sort.component';
import {RegleGemrcnComponent} from './ui/regle-gemrcn/regle-gemrcn.component';
import {IconIsokComponent} from './icon/icon-isok/icon-isok.component';
import {NumberFlowComponent} from './ui/number-flow/number-flow.component';
import {HelpComponent} from './ui/help/help.component';
import {TooltipComponent} from './ui/tooltip/tooltip.component';
import {GraphComponent} from './d3/visuals/graph/graph.component';
import {SHARED_VISUALS} from './d3/visuals/shared';
import {D3_DIRECTIVES} from '../core/d3/directives';
import {PreferencesDialogEditComponent} from './ui/preferences-dialog-edit/preferences-dialog-edit.component';
import {MotDePasseOublieComponent} from './mot-de-passe-oublie/mot-de-passe-oublie.component';
import {UtilisateurAuthComponent} from './utilisateurAuth/utilisateur-auth.component';
import {DynamicFormBsComponent} from './ui/generic-forms/bootstrap/dynamic-form-bs/dynamic-form-bs.component';
import {DynamicFormFieldBsComponent} from './ui/generic-forms/bootstrap/dynamic-form-field-bs/dynamic-form-field-bs.component';
import {TreeModule} from 'primeng/tree';
import {CommonModule} from '@angular/common';
import {TableModule} from 'primeng/table';
import {DynamicFormFieldErrorBsComponent} from './ui/generic-forms/bootstrap/dynamic-form-field-error-bs/dynamic-form-field-error-bs.component';
import {ControlErrorComponent} from './ui/control-error/control-error.component';
import {DateDispoComponent} from './ui/calendar/date-dispo/date-dispo.component';
import {GenericDatagridPnComponent} from './ui/generic-datagrid/primeng/generic-datagrid-pn/generic-datagrid-pn.component';
import {ImgEntityComponent} from './ui/generic-datagrid/img-entity/img-entity.component';
import {PrimengEditorHeaderComponent} from './primeng-editor-header/primeng-editor-header.component';
import {DynamicFormFieldMessageBsComponent} from './ui/generic-forms/bootstrap/dynamic-form-field-message-bs/dynamic-form-field-message-bs.component';
import {BaseProductionComponent} from './base-production/base-production.component';
import {StatutsReceptionComponent} from './reception/statuts-reception/statuts-reception.component';
import {LitigeWarningComponent} from './reception/litige-warning/litige-warning.component';
import {CheckComponent} from './ui/check/check.component';
import {BlacklistInputDirective} from './ui/blacklist-input.directive';
import {IconStepComponent} from './icon/icon-step/icon-step.component';
import {FocusDirective} from './ui/focus.directive';
// @ts-ignore
import {BadgeNotificationComponent} from './ui/badge-notification/badge-notification.component';
import {RouterModule} from '@angular/router';
import {FormComponent} from './ui/generic-forms/bootstrap/form/form.component';
import {
  DxCheckBoxModule,
  DxDataGridModule,
  DxLoadIndicatorModule,
  DxSelectBoxModule,
  DxTreeListModule
} from 'devextreme-angular';
import {ErreurFonctionnelleService} from '../core/services/technique/erreur-fonctionnelle.service';
import {InfoLotmarcheArticleComponent} from './marches/info-lotmarche-article/info-lotmarche-article.component';
import {LegendGridDevExtremeComponent} from './ui/legend-grid-dev-extreme/legend-grid-dev-extreme.component';
import {LeftAppMenuComponent} from './ui/left-app-menu/left-app-menu.component';
import {BreadcrumbComponent} from './ui/breadcrumb/breadcrumb.component';
import {DxPopoverModule} from 'devextreme-angular/ui/popover';
import {TooltipModule} from 'primeng/tooltip';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ColorPickerModule} from 'primeng/colorpicker';
import {DialogModule} from 'primeng/dialog';
import {CalendarModule} from 'primeng/calendar';
import {DropdownModule} from 'primeng/dropdown';
import {SelectButtonModule} from 'primeng/selectbutton';
import {CheckboxModule} from 'primeng/checkbox';
import {EditorModule} from 'primeng/editor';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {ListboxModule} from 'primeng/listbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {PanelModule} from 'primeng/panel';
import {MenuModule} from 'primeng/menu';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {CardModule} from 'primeng/card';
import {ToolbarModule} from 'primeng/toolbar';
import {InputTextModule} from 'primeng/inputtext';
import {InfosVersionComponent} from './ui/infos-version/infos-version.component';
import {PlanningEquipesComponent} from './ui/gestion-unitesproduction/planning-equipes/planning-equipes.component';
import {JoursDecalageComponent} from './ui/gestion-unitesproduction/planning-equipes/jours-decalage/jours-decalage.component';
import {RadioButtonModule} from 'primeng/radiobutton';
import {GrilleRemplacerArticleComponent} from "./article/grille-remplacer-article/grille-remplacer-article.component";
import {MarkdownModule} from "ngx-markdown";
import {FallbackDirective} from "./ui/fallback.directive";
import {MessageService} from "primeng/api";


@NgModule({
    imports: [

        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        TooltipModule,
        ButtonModule,
        ConfirmDialogModule,
        ColorPickerModule,
        DialogModule,
        CalendarModule,
        DropdownModule,
        SelectButtonModule,
        MultiSelectModule,
        CheckboxModule,
        EditorModule,
        TableModule,
        OverlayPanelModule,
        ScrollPanelModule,
        CardModule,
        ListboxModule,
        PanelModule,
        DxDataGridModule,
        DxTreeListModule,
        MenuModule,
        TieredMenuModule,
        DxPopoverModule,
        ToolbarModule,
        InputTextModule,
        RadioButtonModule,
        DxSelectBoxModule,
        DxCheckBoxModule,
        MarkdownModule,
        DxLoadIndicatorModule,

    ],
  declarations: [
    IconproduitFabriqueComponent,
    ViewmodeComponent,
    ReadonlyComponent,
    InputTextComponent,
    ValidationComponent,
    SiteComponent,
    CellButtonComponent,
    ConfirmDialogComponent,
    ButtonSaveComponent,
    ButtonDeleteComponent,
    LoginComponent,
    InputPasswordComponent,
    YoUserHasRightDirective,
    InputFileComponent,
    LoadingComponent,
    BadgeComponent,
    IconLockComponent,
    DraggableDirective,
    DroppableDirective,
    DialogMsgComponent,
    FamilleGemrcnComponent,
    CouleurComponent,
    ButtonSortComponent,
    RegleGemrcnComponent,
    IconIsokComponent,
    NumberFlowComponent,
    HelpComponent,
    TooltipComponent,
    ...SHARED_VISUALS,
    ...D3_DIRECTIVES,
    GraphComponent,
    PreferencesDialogEditComponent,
    MotDePasseOublieComponent,
    UtilisateurAuthComponent,
    DynamicFormBsComponent,
    DynamicFormFieldBsComponent,
    DynamicFormFieldErrorBsComponent,
    ControlErrorComponent,
    DateDispoComponent,
    GenericDatagridPnComponent,
    ImgEntityComponent,
    PrimengEditorHeaderComponent,
    DynamicFormFieldMessageBsComponent,
    BaseProductionComponent,
    StatutsReceptionComponent,
    LitigeWarningComponent,
    CheckComponent,
    BlacklistInputDirective,
    IconStepComponent,
    FocusDirective,
    FallbackDirective,
    BadgeNotificationComponent,
    FormComponent,
    InfoLotmarcheArticleComponent,
    LegendGridDevExtremeComponent,
    LeftAppMenuComponent,
    BreadcrumbComponent,
    InfosVersionComponent,
    PlanningEquipesComponent,
    JoursDecalageComponent,
    GrilleRemplacerArticleComponent,

  ],

  exports: [

    // SPECIFIC
    DndModule,
    IconproduitFabriqueComponent,
    ReadonlyComponent,
    ViewmodeComponent,
    InputTextComponent,
    SiteComponent,
    CellButtonComponent,
    ConfirmDialogComponent,
    ButtonSaveComponent,
    ButtonDeleteComponent,
    LoginComponent,
    InputPasswordComponent,
    YoUserHasRightDirective,
    InputFileComponent,
    LoadingComponent,
    BadgeComponent,
    IconLockComponent,
    DraggableDirective,
    DraggableDirective,
    DroppableDirective,
    DialogMsgComponent,
    FamilleGemrcnComponent,
    TreeModule,
    CouleurComponent,
    ButtonSortComponent,
    RegleGemrcnComponent,
    IconIsokComponent,
    ValidationComponent,
    NumberFlowComponent,
    HelpComponent,
    TooltipComponent,
    ColorPickerModule,
    ButtonSaveComponent,
    ...SHARED_VISUALS,
    ...D3_DIRECTIVES,
    GraphComponent,
    PreferencesDialogEditComponent,
    MotDePasseOublieComponent,
    UtilisateurAuthComponent,
    DynamicFormFieldBsComponent,
    DynamicFormBsComponent,
    ControlErrorComponent,
    DateDispoComponent,
    GenericDatagridPnComponent,
    BadgeNotificationComponent,

    ImgEntityComponent,
    PrimengEditorHeaderComponent, StatutsReceptionComponent, LitigeWarningComponent, CheckComponent, BlacklistInputDirective,
    IconStepComponent,
    FocusDirective,

    FormComponent,
    InfoLotmarcheArticleComponent,
    LegendGridDevExtremeComponent,
    LeftAppMenuComponent, BreadcrumbComponent, PlanningEquipesComponent,
    GrilleRemplacerArticleComponent,


    // DEVEXTREME
    // DxDataGridModule

  ],
  entryComponents: [
    DialogMsgComponent,
    PreferencesDialogEditComponent,
  ],
  providers: [
    MessageService,
    ErreurFonctionnelleService
  ]
})
export class SharedModule {


  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        CanDeactivateGuard,
        DragService
      ]
    };
  }

}
